import { serverTimesampToNormalDate } from "utils/AppUtils";

function TimestampColumn({ timestamp }) {
  return serverTimesampToNormalDate(timestamp);
}

export default TimestampColumn;
